module.exports = __webpack_public_path__ + "img/EDparent.1f0be4a0.jpeg";